module.exports = __webpack_public_path__ + "img/hzLogo7.ee5c4703.png";